// src/services/whatsappDisclaimerService.ts
// ============================================================================
// DESCARGO DE RESPONSABILIDAD DE WHATSAPP — re-cableado a lealify-base (Bloque C).
// ============================================================================
// Antes escribía en Firestore users/{uid}.whatsappDisclaimer. Ahora la aceptación
// se guarda server-side por tenant (tenant_settings skey='whatsapp_disclaimer') vía
// POST /messages/whatsapp/disclaimer. El estado se lee en buildUser desde
// /messages/whatsapp-status y se expone en currentUser.whatsappDisclaimer.
//
// Se conserva la MISMA firma (acceptWhatsAppDisclaimer(uid)) para no tocar
// WhatsAppPage; el `uid` ya no se usa (el tenant sale de la sesión).
// ============================================================================
import { whatsappApi } from '../api/whatsappApi';

/** Versión vigente del texto del descargo. Subir si cambia el contenido legal. */
export const WHATSAPP_DISCLAIMER_VERSION = 'v1';

/**
 * Registra que el dueño del negocio aceptó el descargo de responsabilidad.
 * @param _uid - ignorado (compat de firma); el tenant se resuelve de la sesión.
 */
export async function acceptWhatsAppDisclaimer(
  _uid?: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const res = await whatsappApi.acceptDisclaimer(WHATSAPP_DISCLAIMER_VERSION);
    return res?.ok ? { success: true } : { success: false, error: 'No se pudo guardar la aceptación' };
  } catch (err: any) {
    console.error('[whatsappDisclaimer] Error guardando aceptación:', err);
    return { success: false, error: err?.message || 'Error al guardar la aceptación' };
  }
}
